import React from 'react';

export default React.forwardRef(function CockpitBody({ children }, ref) {
  return (
    <div id="cockpit-item-panel" className={`cockpit-item-panel`} ref={ref}>
      {children}
    </div>
  );
});
